module.exports = __webpack_public_path__ + "static/media/tutorial-draw-risk.83ac53f3.png";